define('drops/gauge/gauge',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/windowSize'
], function ($, lq, Drop, windowSize) {
    'use strict';

    var defaults = {
        data: {
            range: {
                start: -90,
                end: 90
            },
            indicatorPosition: { // in %
                x: '50',
                y: '50'
            },
            indicatorOrigin: { // in %
                x: '50',
                y: '95'
            },
            indicatorScale: 100,
            rotation: 0,
            input: {
                type: 'degrees',
                start: 0,
                end: 100
            }
        }
    };

    function Gauge(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$background = $('<img />')
            .css({
                width: '100%',
                height: '100%'
            });

        this.$indicator = $('<img />')
            .css({
                position: 'absolute'
            });

        this.$element
            .append(this.$background, this.$indicator);
        
        this.hideIndicator();
        if (this.data.indicatorImage) this.setIndicatorImage(this.data.indicatorImage);
        if (this.data.backgroundImage) this.setBackgroundImage(this.data.backgroundImage);
    };

    Drop.extend(Gauge, Drop);

    Gauge.typeName = 'Gauge';

    Gauge.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    Gauge.prototype.postRender = function () {
        this.setupWindowResizeScaling();
    };

    Gauge.prototype.setupWindowResizeScaling = function () {
        if ((this.data.bottom == null || this.data.top == null)
            && (this.data.left == null || this.data.right == null))
            return;

        var self = this;
        windowSize.withOnChanged(function () {
            self.updateIndicator(self.value);
        });
    };

    Gauge.prototype.setBackgroundImage = function (backgroundImage) {
        this.$background.attr('src', lq.getTenantUploads(backgroundImage));
    };

    Gauge.prototype.setIndicatorImage = function (indicatorImage) {
        this.$indicator.attr('src', lq.getTenantUploads(indicatorImage));
    };

    Gauge.prototype.clearValue = function () {
        this.hideIndicator();
    };

    Gauge.prototype.setValue = function (update) {
        this.updateIndicator(update.value);
    };

    Gauge.prototype.updateIndicator = function (value) {
        if (!value && value !== 0) {
            this.hideIndicator();
        } else {
            var position = this.getPositionOfIndicator(value);

            if (position < this.data.range.start)
                position = this.data.range.start;
            else if (position > this.data.range.end)
                position = this.data.range.end;

            this.positionIndicator(position);
            this.showIndicator();
        }

        this.value = value;
    };

    Gauge.prototype.getPositionOfIndicator = function (value) {
        if (this.data.input.type === 'range')
            return (value - this.data.input.start) * (this.data.range.end - this.data.range.start) / (this.data.input.end - this.data.input.start) + this.data.range.start;

        return this.data.range.start < this.data.range.end ?
                this.data.range.start + Number(value) : this.data.range.start - Number(value);
    };

    Gauge.prototype.hideIndicator = function () {
        this.$indicator.css('visibility', 'hidden');
    };

    Gauge.prototype.showIndicator = function () {
        this.$indicator.css('visibility', 'inherit');
    };

    Gauge.prototype.positionIndicator = function (rotation) {
        var xFactor = this.getXScalingFactor();
        var yFactor = this.getYScalingFactor();
        var scaleX = (this.data.indicatorScale / 100) * xFactor;
        var scaleY = (this.data.indicatorScale / 100) * yFactor;

        var transform = 'translate(' + (-1 * this.data.indicatorOrigin.x) + '%, ' + (-1 * this.data.indicatorOrigin.y) + '%) rotate(' + rotation + 'deg) scale(' + scaleX + ', ' + scaleY + ')';
        var transformOrigin = this.data.indicatorOrigin.x + '% ' + this.data.indicatorOrigin.y + '%';
        
        this.$indicator
            .css({
                left: this.data.indicatorPosition.x + '%',
                top: this.data.indicatorPosition.y + '%',

                '-ms-transform': transform,
                '-webkit-transform': transform,
                'transform': transform,

                '-webkit-transform-origin': transformOrigin,
                '-moz-transform-origin': transformOrigin,
                '-o-transform-origin': transformOrigin,
                'transform-origin': transformOrigin
            });
    };

    Gauge.prototype.getXScalingFactor = function() {
        return this.$element.width() / this.data.size.x;
    };

    Gauge.prototype.getYScalingFactor = function () {
        return this.$element.height() / this.data.size.y;
    };

    return Gauge;
});
